import * as React from "react";
import * as cn from "classnames";
import { AdUnitFormat, campaignCreativesForm } from "@store";

export interface AdFormatsComponentProps {
    value: string | null;
    onChange: (newValue: string | null) => void;
    adFormats: AdUnitFormat[];
    creativesFormEvents: typeof campaignCreativesForm.types.eventBindings;
    onSetAdUnitFormat: (AdUnitFormat: string) => void;
}

export class AdFormatsComponent extends React.Component<AdFormatsComponentProps, any> {
    constructor(props: AdFormatsComponentProps) {
        super(props);
    }

    render() {
        const { value, adFormats, onSetAdUnitFormat } = this.props;

        return (
            <>
                <div className="adFormats-block tour-campaign-ad-formats">
                    <div className="adFormat-item">
                        <h4>Mobile</h4>
                        <div className="item-inner-wrapper">
                            {adFormats &&
                                adFormats.map((format, index) => (
                                    <div
                                        key={index}
                                        className="device-item"
                                        onClick={() => onSetAdUnitFormat(format.size)}
                                    >
                                        <img className="adFormats-icon" src={format.icon} />
                                        <label className={cn("common-radio custom-adFormat-radio")}>
                                            <input
                                                type="radio"
                                                name=""
                                                value={format.size}
                                                id=""
                                                checked={value === format.size}
                                                onChange={() => onSetAdUnitFormat(format.size)}
                                            />
                                            <span className="checkmark" />
                                            <span className="adFormat-title">{format.name}</span>
                                        </label>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
